<template>
  <el-menu @select="handleSelect" style="border: none;">
    <el-menu-item
      v-for="it in itemList"
      :key="it.id"
      :index="`${it.id}`"
      :disabled="it.disabled"
      class="flex flex-row v-center"
      style="height: 34px; line-height: 34px; padding-right: 0px;"
      ><check-item
        :label="it.name"
        :value="it.id"
        :checked="it.checked"
        :indeterminate="it.indeterminate"
        :is-leaf="it.isLeaf || isLeaf"
        :allowed-check="allowedCheck"
        @change="handleCheck"
      />
    </el-menu-item>
  </el-menu>
</template>
<script>
import { Menu, MenuItem } from "element-ui";
import CheckItem from "@/components/list/CheckItem";
const equalValue = (left, right) => {
  return `${left}` === `${right}`;
};
const checkLeaf = (items, id) => {
  if (!Array.isArray(items) || !items.length) {
    return false;
  }
  const item = items.find((it) => equalValue(it.id, id));
  if (item === undefined) {
    return false;
  }
  return !!item.isLeaf;
};
const findValue = (items, menuIndex) => {
  if (!Array.isArray(items) || !items.length) {
    return undefined;
  }
  const item = items.find((it) => equalValue(it.id, menuIndex));
  return item && item.id;
};
export default {
  name: "check-list",
  components: {
    CheckItem,
    [Menu.name]: Menu,
    [MenuItem.name]: MenuItem,
  },
  props: {
    items: {
      type: Array,
    },
    indeterminateValues: {
      type: Array,
    },
    isLeaf: {
      type: Boolean,
    },
    value: {
      type: Array,
    },
    allowedCheck: {
      type: Boolean,
      default: false,
    },
    path: {
      type: Array,
    },
  },
  model: {
    prop: "value",
    event: "change",
  },
  data() {
    return {
      checkedList: [],
      itemList: [],
    };
  },
  watch: {
    value(value) {
      this.checkedList = Array.isArray(value) ? [...value] : [];
    },
    indeterminateValues(indeterminateValues) {
      this.updateItemList(this.items, this.checkedList, indeterminateValues);
    },
    items(items) {
      this.updateItemList(items, this.checkedList, this.indeterminateValues);
    },
    checkedList(checkedList) {
      this.updateItemList(this.items, checkedList, this.indeterminateValues);
    },
  },
  mounted() {
    const { items, value } = this.$props;
    this.checkedList = Array.isArray(value) ? [...value] : [];
    this.updateItemList(items, this.checkedList);
  },
  methods: {
    updateItemList(items, checkedList, indeterminateValues) {
      const newItems = items || [];
      if (checkedList.length) {
        this.itemList = newItems.map((item) => {
          const indeterminate =
            Array.isArray(indeterminateValues) &&
            indeterminateValues.length > 0 &&
            indeterminateValues.includes(item.id);
          const checked = checkedList.some((it) => equalValue(item.id, it));
          return { ...item, checked, indeterminate };
        });
      } else {
        this.itemList = newItems.map((it) => {
          const indeterminate =
            Array.isArray(indeterminateValues) &&
            indeterminateValues.length > 0 &&
            indeterminateValues.includes(it.id);
          return { ...it, checked: false, indeterminate };
        });
      }
    },
    handleSelect(index) {
      const { items } = this.$props;
      const isLeaf = this.itemIsLeaf(index);
      const value = findValue(items, index);
      this.$emit("click", { value, isLeaf });
    },
    handleCheck({ value, checked }) {
      const isLeaf = this.itemIsLeaf(value);
      this.$emit("check", { value, checked, isLeaf });
      if (checked) {
        if (!this.checkedList.some((it) => equalValue(it, value))) {
          this.checkedList.push(value);
        }
      } else {
        this.checkedList = this.checkedList.filter(
          (it) => !equalValue(it, value)
        );
      }
      this.emitChange(this.checkedList);
    },
    itemIsLeaf(id) {
      const { items } = this.$props;
      return checkLeaf(items, id) || this.$props.isLeaf;
    },
    checkAll() {
      this.checkedList = this.$props.items.map((it) => it.id);
      this.emitChange(this.checkedList);
    },
    cleanAll() {
      this.checkedList = [];
      this.emitChange(this.checkedList);
    },
    emitChange(checkedList) {
      this.$emit("change", checkedList);
    },
  },
};
</script>
